import React, { FC, useState } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';
import ICONS from '../../constants/icons';

import useGetUsersWithEntityPermission from 'hooks/users/useGetUsersWithEntityPermission';

import { EntityType } from 'models/entity-permission.model';

import ShareEditModal from './ShareEditModal';

interface EntityPermissionMainProps {
    formulaId: number;
    hasWriteAccess: boolean;
}
const EntityPermissionMain: FC<EntityPermissionMainProps> = ({
    formulaId,
    hasWriteAccess,
}) => {
    const { data = [] } = useGetUsersWithEntityPermission(
        EntityType.formula,
        formulaId?.toString(),
    );

    const [isShareEditModalOpen, setIsShareEditModalOpen] =
        useState<boolean>(false);

    const onClick = () => {
        setIsShareEditModalOpen(true);
    };

    const onClose = () => {
        setIsShareEditModalOpen(false);
    };
    return (
        <>
            <EntityPermissionContainer onClick={onClick}>
                {hasWriteAccess ? (
                    <>
                        <ICONS.groupUsers />
                        <Text> {data?.length} </Text>
                    </>
                ) : (
                    <>
                        <ICONS.eye />
                        <Text> View only </Text>
                    </>
                )}
            </EntityPermissionContainer>
            {isShareEditModalOpen && (
                <ShareEditModal
                    entityPermissionUsers={data}
                    onClose={onClose}
                    hasWriteAccess={hasWriteAccess}
                    formulaId={formulaId}
                />
            )}
        </>
    );
};

const EntityPermissionContainer = styled.button({
    display: 'flex',
    padding: aampeTheme.spacing4(2, 4),
    gap: aampeTheme.spacing4(1),
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    borderRadius: aampeTheme.borderRadius.default,
    background: aampeTheme.colors.white,
    cursor: 'pointer',
});

const Text = styled.span({
    fontSize: aampeTheme.size.font.default,
    fontWeight: aampeTheme.weights.medium,
    color: aampeTheme.colors.neutral09,
});
export default EntityPermissionMain;
